
export class AvailabilityDetails {
    public availabilityType?: string;
    public availabilityTypeLabel?: string;
    public start?: string;
    public end?: string;
}

export class SlotItem {
    public date?: string;
    public capacity?: string;
    public insideSla?: boolean;
    public metadata?: any;
}

export class AvailabilityBand {
    public availabilityDetails?: AvailabilityDetails;
    public slots?: SlotItem[];
    public earliestSlot?: SlotItem;
    public optimumSlot?: SlotItem;
    public anySlotsInsideSla?: boolean;
}

export class AppointmentAvailability {
    constructor(
        isPreferences?: boolean,
        hasSlaAvailability?: boolean,
        earliestAvailabilityType?: string,
        statusCode?: number,
        availabilities?: AvailabilityBand[]) {

        this.isPreferences = isPreferences;
        this.hasSlaAvailability = hasSlaAvailability;
        this.earliestAvailabilityType = earliestAvailabilityType;
        this.statusCode = statusCode;
        this.availabilities = availabilities;

    }
    public isPreferences?: boolean;
    public hasSlaAvailability?: boolean;
    public earliestAvailabilityType?: string;
    public statusCode?: number;
    public availabilities?: AvailabilityBand[];
}

export class EarliestSlot {
    public date?: string;
    public insideSla?: boolean;
    public availabilityType?: string;
}

export class WOEnvelope {
    constructor(
        id?: string,
        contractor?: Contractor,
        jobStatus?: string,
        jobNo?: string,
        isAppointable?: boolean,
        isAppointmentRetrievalFailed?: boolean,
        operationKey?: string,
        appointmentAvailability?: AppointmentAvailability,
        appointmentSlotSelected?: any,
        booking?: Booking) {

        this.id = id;
        this.contractor = contractor;
        this.jobStatus = jobStatus;
        this.jobNo = jobNo;
        this.isAppointable = isAppointable;
        this.isAppointmentRetrievalFailed = isAppointmentRetrievalFailed;
        this.operationKey = operationKey;
        this.appointmentAvailability = appointmentAvailability;
        this.appointmentSlotSelected = appointmentSlotSelected;
        this.booking = booking;

    }
    public id?: string;
    public contractor?: Contractor;
    public jobStatus?: string;
    public jobNo?: string;
    public isAppointable?: boolean;
    public isAppointmentRetrievalFailed?: boolean;
    public operationKey?: string;
    public appointmentAvailability?: AppointmentAvailability;
    public appointmentSlotSelected?: any;
    public booking?: Booking;
}

export class Booking {
    public status?: string;
    public error?: any;
}

export class Contractor {
    constructor(code?: string, name?: string) {
        this.code = code;
        this.name = name;
    }
    public code?: string;
    public name?: string;
}

export class Bundle {
    constructor(originalWO?: WOEnvelope, dmc?: WOEnvelope) {
        this.originalWO = originalWO;
        this.dmc = dmc;
    }
    public originalWO?: WOEnvelope;
    public dmc?: WOEnvelope;
}

export class CalendarPayload {
    public availabilities?: AvailabilityBand[];
    public isPreferences?: boolean;
    public hasSlaAvailability?: boolean;
    public earliestAvailabilityType?: string;
}